<template>
  <div
    v-loading="loading"
    class="bc-report-header"
  >
    <div class="top">
      <span class="name">{{ name }}</span>
      <span
        v-if="infoData.regStatus"
        class="status"
        :class="{ 'red-status': ['吊销', '注销'].includes(infoData.regStatus) }"
      >{{ infoData.regStatus }}</span>
    </div>
    <div class="info">
      <span
        v-for="i in infos"
        :key="i.key"
        class="b-item"
      >
        <span class="item-title">{{ i.value }}</span>
        <el-tooltip
          placement="top-start"
          :content="infoData[i.key]"
          :disabled="!infoData[i.key]"
          :open-delay="300"
        >
          <span
            class="item-info text-overflow"
            :class="{ 'is-href': (i.isEmail || i.isWebsite) && infoData[i.key] }"
            @click="tapHref(i)"
          >
            {{ infoData[i.key] || '-' }}
          </span>
        </el-tooltip>
      </span>
    </div>
    <div
      class="bottom"
    >
      <span>
        <i class="one one-info" />
        工商信息来源于公开信息
      </span>
      <span
        slot="reference"
        class="pointer statement"
        @click="statementShow=true"
      >
        <i class="one one-menu-clerk" />
        法治体检声明
      </span>
    </div>
    <el-dialog
      title="法治体检声明"
      :visible="statementShow"
      :center="true"
      :modal-append-to-body="false"
      @close="statementShow=false"
    >
      <div class="law-exam-statement">
        <span>企业法律风险直接影响企业经营和发展，而对企业进行法治体检，可以有效保障企业梳理和排查存在的法律风险，并探求解决方法，切实提高企业的风险防范能力和治企能力，将企业风险由事后化解变为事前预防，促进企业健康发展。</span>
        <span>为出具本体检报告，本所律师特作如下声明：</span>
        <span>(1) 本报告系依据法治体检服务报告出具日以前已经发生或存在的事实，根据可适用的中国法律、法规和规范性文件而出具。</span>
        <span>(2) 本所及本所律师对本报告所涉及的有关事实的了解，最终依赖贵司所作陈述及公开渠道查询的相关资料。</span>
        <span>(3) 本所及本所律师同意将本报告作为贵司风险防范和经营规范之用，未经本所及本所律师书面同意，贵司及关联公司不得将本报告用作其他任何目的。</span>
        <span>(4) 本报告各部分之间不可分割。</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import lawExamService from '@/service/law-exam'
import { buildValidURL } from '@/utils/http'
export default {
  name: 'BcReportHeader',
  props: {
    name: {
      type: String,
      default: '',
    },
    companyId: {
      type: String,
      default: '',
    },
    isLawExam: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      loading: false,
      statementShow: false,
      infos: [
        { key: 'phoneNumber', value: '电话：' },
        { key: 'email', isEmail: true, value: '邮箱：' },
        { key: 'websiteList', isWebsite: true, value: '网址：' },
        { key: 'industry', value: '所属行业：' },
        { key: 'legalPersonName', value: '法定代表人：' },
      ],
      infoData: {},
    }
  },
  mounted () {
    this.getBaseInfo()
  },
  methods: {
    getBaseInfo () {
      let params = {
        companyId: this.companyId,
      }
      this.loading = true
      if (this.isLawExam) {
        lawExamService.reportRequestBaseInfo('companyBaseInfo', params).then(res => {
          this.infoData = res.data || {}
          localStorage.setItem('currentIndustry', this.infoData.industry)
          this.loading = false
        }).catch(_ => {
          this.loading = false
        })
      }
    },
    // a 标签设置...时不成功 所以使用js模拟
    tapHref (i) {
      let value = this.infoData[i.key]
      if (!value) return
      if (i.isEmail || i.isWebsite) {
        let a = document.createElement('a')
        a.href = i.isEmail ? `mailto: ${value}` : buildValidURL(value)
        if (i.isWebsite) a.target = '_blank'
        a.click()
      }
    },
  },
}
</script>

<style lang="stylus">
.bc-report-header
  background-color #fff
  border-radius 2px
  padding 16px 30px 18px
  box-sizing border-box
  .top
    display flex
    align-items center
    .name
      margin-right 13px
      font-size 16px
      font-weight 500
      max-width calc(100% - 100px)
    .status
      border-radius 2px
      font-size 12px
      font-weight 600
      border 1px solid #9ad855
      height 18px
      padding 0 10px
      color #9ad855
      transform scale(0.91)
      &.red-status
        color #ea5b47
        border-color #ea5b47
  .info
    display flex
    flex-wrap wrap-reverse
    margin-top 26px
    .b-item
      width 25%
      color #666666
      font-size 12px
      display flex
      align-items center
      margin-bottom 12px
      &:not(:nth-of-type(3n + 3))
        margin-right 5%
      .item-info
        flex 1
        &.is-href
          text-decoration underline
          cursor pointer
          &:hover
           color #ed6c00
  .bottom
    font-size 12px
    color #999999
    padding-top 16px
    margin-top 8px
    display flex
    border-top 1px solid #f4f4f4
    span
      display flex
      align-items center
      &:first-child
        margin-right 30px
      .one
        display flex
        margin-right 2px
    .statement:hover
      color #ed6c00
  .law-exam-statement
    font-size 13px
    line-height 1.6
    text-indent 25px
    span
      display block
      margin-bottom 5px
</style>
